import Vue from "vue";
import { mapGetters } from "vuex";

import { ErrorLogService, EventTrackingService, PartDetailServices } from "@/services";

import { LoadingSpinner, StaticFormControl } from "@/components";
import { inputValidateState } from "@/components/mixins/inputValidateState";

import { default as SendError } from "../SendError.vue";
import { default as ThankYou } from "../ThankYou.vue";

import { IUserInfo } from "@/types";

export default Vue.extend({
    name: "AddCrossReference",
    mixins: [inputValidateState],
    components: {
        ThankYou,
        LoadingSpinner,
        SendError,
        StaticFormControl,
    },
    computed: {
        ...mapGetters(["user", "getContentItem", "activeAccountId", "SiteName"]),
        formIsValid(){
            return this.oem && this.competitivePart && this.sourceOfInformation;
        }
    },
    props: {
        oemPartCode: {
            type: String,
            default: "",
        },
        partDescription: {
            type: String,
            default: "",
        }
    },

    data: () => ({
        showThankYou: false,
        showSendError: false,
        submittingForm: false,
        errorMessage: "",
        haveVisitedOemInput: false,
        haveVisitedCompetitivePartInput: false,
        haveVisitedSourceOfInformationInput: false,

        // form fields
        oem: "",
        competitivePart: "",
        sourceOfInformation: "",
        comment: "",
    }),
    methods: {
        async submitForm() {
            try {
                this.showThankYou = false;
                this.submittingForm = true;

                var headerParams = {
                    oemPartCode: this.oemPartCode,
                    siteName: this.SiteName,
                    partDescription: this.partDescription,
                    suggestOem: this.oem,
                    suggestPartNumber: this.competitivePart,
                    suggestSource: this.sourceOfInformation,
                    suggestComments: this.comment
                }
                await PartDetailServices.sendCrossAddEmail(headerParams, this.user);

                EventTrackingService.trackEvent({
                  category: "Part Detail",
                  action: "Suggest Cross",
                  label: `${this.oem}-${this.oemPartCode}`,
                  value: 1,
                });

                this.showThankYou = true;
            } catch (err) {
                this.showSendError = true;
                this.errorMessage = ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.submittingForm = false;
            }
        },
        hideForm(){
            this.$emit("hide");
        },
        checkRequiredField(field: any, inputHasBeenVisited: boolean){
            if(!inputHasBeenVisited){
                return null;
            }
            if(field){
                return true;
            }
            return false;
        }
    }
});
